import { render, staticRenderFns } from "./articlelist.vue?vue&type=template&id=3096a86a"
import script from "./articlelist.vue?vue&type=script&lang=js"
export * from "./articlelist.vue?vue&type=script&lang=js"
import style0 from "./articlelist.vue?vue&type=style&index=0&id=3096a86a&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3096a86a')) {
      api.createRecord('3096a86a', component.options)
    } else {
      api.reload('3096a86a', component.options)
    }
    module.hot.accept("./articlelist.vue?vue&type=template&id=3096a86a", function () {
      api.rerender('3096a86a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/articlemanagement/articlelist.vue"
export default component.exports